import { ShieldAlert } from "lucide-react";

import { fmtPeso } from "../../utils/formatters";

// WP8 target-v2: why this Rider cannot receive new work.
//
// The hold is opened by a short count at the Business counter and lifted only by
// resolving that discrepancy. Nothing here is an action - a Rider cannot clear
// their own cash hold, and offering a button that looked like they could would be
// worse than saying nothing.
//
// It lives in its own component because the Rider needs it in two places for two
// different reasons: on an active trip, beside the cash they are still carrying;
// and on the workspace home, where a Rider with no trip goes to find out why no
// work is arriving. That second place is the one that matters - a hold is opened
// when a trip ends, which is exactly when the Rider has no run screen to look at.
//
// Renders nothing unless the Rider is actually held. Before cutover the endpoint
// has no target table to read, so `holds` is null and this stays invisible.
export default function RiderWorkHoldNotice({ holds, className = "" }) {
  if (!holds?.blocksNewAssignments) return null;

  const cause = holds.items?.[0]?.cause || null;

  return (
    <div
      className={`rounded-xl border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/40 dark:bg-amber-500/10 ${className}`}
    >
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900 dark:text-amber-200">
        <ShieldAlert className="h-4 w-4 shrink-0" aria-hidden="true" />
        You cannot receive new trips
      </p>
      <p className="mt-1 max-w-prose text-sm text-amber-900/90 dark:text-amber-200/90">
        {cause
          ? `A count came up ${String(cause.direction).toLowerCase()} by `
            + `${fmtPeso(cause.amountCents)} and is still being looked into. `
          : "A cash discrepancy is still being looked into. "}
        That gets lifted when it is resolved, not from here. You can still hand over
        anything you are carrying.
      </p>
    </div>
  );
}
